module.exports = __webpack_public_path__ + "static/media/logo-펫핀스@2x.19c15456.png";